import { useHistory } from 'react-router-dom';
import { isIOS, isMobile, isTablet } from 'react-device-detect';
import { BannerBox, BoxInImage } from '../HomePage';
import { useHomePageContext } from '../../context/HomePageContext';
import { getCurrentLang } from '../../libs/lang';
import { S3_URL } from '../../libs/common';

const isMobileView = isMobile && !(isIOS && isTablet);

export const HomeBanner3 = () => {
  const { state } = useHomePageContext();
  const history = useHistory();

  const goBannerUrl = (url, event) => {
    const urlRegex = /^(http|https):\/\//;
    if (event !== null) {
      history.push(`/events/view/${event}`);
    } else {
      if (urlRegex.test(url)) {
        window.open(url, '_blank');
      } else {
        history.push(url);
      }
    }
  };

  const bannerMap = {
    kr: state.data.homeBannerListKo,
    en: state.data.homeBannerListEn,
    jp: state.data.homeBannerListJp,
  };

  const lang = getCurrentLang();
  const bannerList = bannerMap[lang] || [];

  const currentBanner = bannerList.find((x) => x.banner_type === 'home_3') || {};
  if (!currentBanner.banner_img && !currentBanner.banner_mob_img) return null;

  const bannerImage = isMobileView ? currentBanner.banner_mob_img : currentBanner.banner_img;
  console.log("bannerImage: ", bannerImage);

  return (
    <BannerBox
      style={{
        marginTop: '5vw',
        position: 'relative',
        cursor: 'pointer',
        marginLeft: '10px',
        marginRight: '10px',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      }}
      onClick={() => goBannerUrl(currentBanner.banner_url, currentBanner.banner_event_id)}
    >
      <BoxInImage
        style={{
          backgroundImage: `url(${S3_URL(bannerImage)})`,
        }}
      />
    </BannerBox>
  );
};

export default HomeBanner3;
